import React from 'react';
import AvatarIcon from '@/components/AvatarIcon';
import useAuth from '@/hooks/useAuth';
import { colorVariant } from './colorVariant';
import cn from '@/utils/cn';

const WRAPPER = 'flex items-center gap-2 pl-2';

const NAME = cn(colorVariant({ text: 'white' }), 'text-xs font-medium break-words');

const UserIcon = () => {
  const { business, customer, photoURL, businessPhotoURL } = useAuth()!;
  const displayName = business?.name ?? customer?.preferredName ?? '';
  const displayPhoto = business ? businessPhotoURL : photoURL;

  return (
    <div className={WRAPPER}>
      <AvatarIcon key="user-icon-avatar" name={displayName} imgSrc={displayPhoto} variant="xs" />
      <span className={NAME}>{displayName}</span>
    </div>
  );
};

export default UserIcon;
